import { useAnalytics } from "@lazarentertainment/analytics-collector"
import { useChannelContext } from "client/components/channel"
import { ProductHighlightFragment } from "client/graphql/commerce-v2-api"
import { ScrollWrapper } from "client/packages/commerce/components/ui/styles/Containers"
import { Dispatch, SetStateAction } from "react"
import styled from "styled-components"

import MultiProductTile from "./TargetMultiProductTile"

const ProductsListingsWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(142px, 100%), 1fr));
  justify-content: center;
  grid-column-gap: 8px;
  grid-row-gap: 16px;
  padding: 8px;
`

function getVisibleProducts(
  visibleProductIds: string[],
  products: ProductHighlightFragment[],
) {
  return visibleProductIds
    .map((id) => {
      return products.find((product) => product.id === id)
    })
    .filter((product): product is ProductHighlightFragment => !!product)
}

export type MultiProductSelectionProps = {
  featuredProductId?: string | null
  visibleProductIds: string[]
  products: ProductHighlightFragment[]
  setCurrentProductId?: Dispatch<SetStateAction<string | null>>
  currencyCode: string
}

const MultiProductSelection = ({
  featuredProductId,
  visibleProductIds,
  products,
  setCurrentProductId = () => {},
  currencyCode,
}: MultiProductSelectionProps) => {
  const { analytics } = useAnalytics()
  const { channelId, broadcastId, recordingId } = useChannelContext()

  const visibleProducts = getVisibleProducts(visibleProductIds, products)

  const featuredProduct = products.find((product) => {
    return product.id === featuredProductId
  })

  return (
    <ScrollWrapper style={{ padding: "10px", height: "100%" }}>
      <ProductsListingsWrapper>
        {featuredProduct !== undefined && (
          <MultiProductTile
            product={featuredProduct}
            onClick={() => {
              analytics.track("target_view_product", {
                channelId,
                broadcastId,
                recordingId,
                productId: featuredProduct.id,
              })
              setCurrentProductId(featuredProduct.id)
            }}
            isFeatured
            currencyCode={currencyCode}
          />
        )}
        {visibleProducts.map((product) => {
          return (
            <MultiProductTile
              key={product.id}
              product={product}
              onClick={() => {
                analytics.track("target_view_product", {
                  channelId,
                  broadcastId,
                  recordingId,
                  productId: product.id,
                })
                setCurrentProductId(product.id)
              }}
              currencyCode={currencyCode}
            />
          )
        })}
      </ProductsListingsWrapper>
    </ScrollWrapper>
  )
}

export default MultiProductSelection
